export default __webpack_public_path__ + "static/media/registerImage.cdcf25ca.svg";